import axios from "axios";
import { HttpCodes, tokenStatus, tokenType } from "../../../modules/constants";
import { setOpenAuthModal, closeModalGoHome } from "../../../modules/login";

const VALIDATE_ACCOUNT = "VALIDATE_ACCOUNT";
const VALIDATE_ERROR = "VALIDATE_ERROR";
const SET_TOKEN_VALID = "SET_TOKEN_VALID";

const getAccountValidated = (state) => state?.accountValidated;
const getError = (state) => state?.error;
const getIsTokenValid = (state) => state?.isTokenValid;

const initialState = {
  accountValidated: false,
  error: null,
  isTokenValid: "",
};

export const confirmAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_ACCOUNT:
      return {
        ...state,
        accountValidated: true,
      };
    case VALIDATE_ERROR:
      return {
        ...state,
        error: action.data.error,
      };
    case SET_TOKEN_VALID:
      return {
        ...state,
        isTokenValid: action.data.isTokenValid,
      };
    default:
      return state;
  }
};

export const validate = (token) => async (dispatch) => {
  try {
    await axios.post(`/api/account/confirmation`, {
      Token: token,
    });
    return dispatch({
      type: VALIDATE_ACCOUNT,
    });
  } catch (error) {
    const status = error?.response?.status;
    if (status === HttpCodes.FORBIDDEN) {
      return dispatch({
        type: VALIDATE_ERROR,
        data: { error: error.response.data },
      });
    }
    return dispatch({
      type: VALIDATE_ERROR,
      data: { error },
    });
  }
};

export const verifyToken = (token) => (dispatch) => {
  return axios
    .post(`/api/account/validatetoken`, {
      Token: token,
      TokenType: tokenType.registration,
    })
    .then((r) => {
      const isTokenValid = r.data.TokenStatus === tokenStatus.valid;
      return dispatch({
        type: SET_TOKEN_VALID,
        data: { isTokenValid },
      });
    })
    .catch((error) => {
      return dispatch({
        type: VALIDATE_ERROR,
        data: { error },
      });
    });
};

export const mapStateToProps = (state) => {
  return {
    accountValidated: getAccountValidated(state),
    error: getError(state),
    isTokenValid: getIsTokenValid(state),
  };
};

export const mapDispatchToProps = {
  verifyToken,
  validate,
  setOpenAuthModal,
  closeModalGoHome,
};
